import React, { useEffect, useState } from "react";

import { Botao, CampoEstatico, Card, Col, Row, TipoCampoEstatico } from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade } from "../../../../entidades";

interface IProps {
  dataSalario: string;
  valorSalario: number;
  plano: PlanoVinculadoEntidade | null;
}

export const Header: React.FC<IProps> = ({
  dataSalario,
  valorSalario,
  plano
}) => {
  const [Esconder, setEsconder] = useState<boolean>(true);
  const [SalarioEscondido, setSalarioEscondido] = useState<string>("-");

  useEffect(() => {
    (async () => {
      try {
        const salario = `R$ ${valorSalario.toFixed(2).replaceAll(".", ",").replaceAll(/\d/gm, "*")}`;
        setSalarioEscondido(salario);
      } catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        console.log(Error);
      }
    })();
  }, [valorSalario]);

  return (
    <Row>
      <Col tamanho={"md-6"}>
        <Card titulo={plano.DS_PLANO}>
          {plano.DS_CATEGORIA}
        </Card>
      </Col>

      <Col tamanho={"md-6"}>
        <Card titulo={"Data de Inscrição"}>
          {plano.DT_INSC_PLANO}
        </Card>
      </Col>
      <Col tamanho={"md-6"}>
        <Card titulo={"Salário de Participação"} tipoBadge={Card.TipoBadge.secondary} textoBadge={dataSalario}>
          <CampoEstatico valor={Esconder ? SalarioEscondido : valorSalario} tipo={Esconder ? TipoCampoEstatico.texto : TipoCampoEstatico.dinheiro} />
          <Botao
            className={"mt-2"}
            titulo={Esconder ? "Mostrar" : "Esconder"}
            onClick={() => setEsconder(!Esconder)}
            icone={Esconder ? "fas fa-eye" : "fas fa-eye-slash"}
            usaLoading
          />
        </Card>
      </Col>
      {/* <Col tamanho={"md-6"}>
        <Card titulo={"Regime de Tributação"}>
          {plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
        </Card>
      </Col> */}
    </Row>
  )
}